import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SYSTEM } from 'src/app/enums/system.enum';
import { TicketModel } from 'src/app/models/ticket';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';
import { TermsDialogComponent } from '../terms-dialog/terms-dialog.component';

interface DataModel { 
  tickets: TicketModel[]
  createdAt: string
  expired_date: string
  local_order_id: number | null
  order_date: string
  order_tx_number: null | string | number
  payment: null | any
  start_date: string
  status: "unpaid" | "paid"
  system: SYSTEM
}

interface TableDataModel {
  system: string
  day: number | string
  quantity: number,
  price_one: number,
  totalPrice: number
}

@Component({
  selector: 'app-receipt-dialog',
  templateUrl: './receipt-dialog.component.html',
  styleUrls: ['./receipt-dialog.component.css']
})
export class ReceiptDialogComponent implements OnInit {
  reference: TableDataModel[] = new Array();
  readonly TABLE_COL: string[] = ["no","system", "day", "quantity", "price_one", "total_price"];
  isAgree: AbstractControl;
  termAndCondition: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DataModel,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.termAndCondition = environment.term_condition_url;
    this.isAgree = this.fb.control(false);
    const data = this.data;
    const ticket = data.tickets[0];
    this.reference = [
      {
        system: data.system,
        day: ticket.ticket_type.name,
        price_one: ticket.price,
        quantity: data.tickets.length,
        totalPrice: ticket.price * data.tickets.length
      }
    ];
  }

  onAgree() {
    this.dialog.open(TermsDialogComponent, {
      width: '1000px',
			disableClose: true,
			autoFocus: false,
      data: {
        type: 'payment'
      }
    })
    .afterClosed()
    .subscribe( result => {
      if (result) {
        this.isAgree.setValue(true);
        this.loadingService.setLoading(false);
      }
    })
  }
}
